var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ButtonBorderedKVBase, ButtonKVBase, CustomBootstrapTable, DefaultModal, IconButton } from '@/presentation/components';
import { IconAddSimple, IconEdit, IconTrash } from '@/presentation/components/icons';
import { TOTAL_STUDENTS_LIMIT_IN_SEMI_ANNUAL } from '@/presentation/constants/stripe-constants';
import { mapToCardinal } from '@/presentation/functions/cardinal';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
import classNames from 'classnames';
import React from 'react';
import { useRecoilState, useResetRecoilState } from 'recoil';
import { manageStudentsAtom } from '../atoms';
import { addStudentsManuallyAtom } from './atoms';
import ModalAddStudent from './modal-add-student';
import Styles from './modal-add-students-styles.scss';
import { ALL_GRADES_ADD } from '@/presentation/constants/class-grades';
import { isMobile } from 'mobile-device-detect';
const columns = [
    {
        dataField: 'firstName',
        text: 'First Name',
        headerStyle: { width: '25%' },
        sort: true
    },
    {
        dataField: 'lastName',
        text: 'Last Name',
        headerStyle: { width: '25%' },
        sort: true
    },
    {
        dataField: 'email',
        text: 'Email',
        headerStyle: { width: '30%' },
        sort: true
    },
    {
        dataField: 'classGrade',
        text: 'Class Grade',
        headerStyle: { width: '10%' },
        sort: true
    },
    {
        dataField: 'actions',
        text: 'Actions',
        headerStyle: { width: '10%' }
    }
];
const ModalAddStudentsManually = ({ validationAddStudent, saveCsvFile, idClient }) => {
    var _a, _b, _c, _d, _e;
    const [addStudentsManuallyState, setAddStudentsManuallyState] = useRecoilState(addStudentsManuallyAtom);
    const resetAddStudentsManuallyState = useResetRecoilState(addStudentsManuallyAtom);
    const [manageStudentsState, setManageStudentsState] = useRecoilState(manageStudentsAtom);
    const { showCustomError } = useCustomToast({
        containerId: 'main-dashboard-container'
    });
    // const closeMainModal = (): void => setAddStudentsManuallyState(prev => ({ ...prev, mainModal: false }));
    const toggleDeleteModal = (flag) => setAddStudentsManuallyState(prev => (Object.assign(Object.assign({}, prev), { studentForRemove: flag })));
    const confirmDeleteStudent = () => {
        const cloneArray = [...addStudentsManuallyState.studentsForSave];
        const newArray = cloneArray.filter(i => i.email !== addStudentsManuallyState.studentForRemove.email);
        setAddStudentsManuallyState(prev => (Object.assign(Object.assign({}, prev), { studentsForSave: newArray, studentForRemove: null })));
    };
    const handleCancel = () => {
        setAddStudentsManuallyState(prev => (Object.assign(Object.assign({}, prev), { mainModal: false })));
        resetAddStudentsManuallyState();
    };
    const updateStudent = (item) => {
        setAddStudentsManuallyState(prev => (Object.assign(Object.assign({}, prev), { studentForEdit: item, modalAddStudent: true })));
    };
    const proceedToPayment = () => __awaiter(void 0, void 0, void 0, function* () {
        var _f, _g;
        try {
            // save the students
            setAddStudentsManuallyState(prev => (Object.assign(Object.assign({}, prev), { isLoading: true })));
            const body = {
                idClient,
                idClass: (_f = addStudentsManuallyState === null || addStudentsManuallyState === void 0 ? void 0 : addStudentsManuallyState.classData) === null || _f === void 0 ? void 0 : _f.id,
                students: addStudentsManuallyState.studentsForSave.map(item => {
                    var _a;
                    return ({
                        firstName: item.firstName,
                        lastName: item.lastName,
                        email: item.email,
                        title: '',
                        grades: [(_a = ALL_GRADES_ADD === null || ALL_GRADES_ADD === void 0 ? void 0 : ALL_GRADES_ADD.find(data => { var _a; return (data === null || data === void 0 ? void 0 : data.label) === ((_a = item === null || item === void 0 ? void 0 : item.idClassSelected) === null || _a === void 0 ? void 0 : _a.value); })) === null || _a === void 0 ? void 0 : _a.value] || []
                    });
                }),
                forceCreateClass: !((_g = addStudentsManuallyState === null || addStudentsManuallyState === void 0 ? void 0 : addStudentsManuallyState.classData) === null || _g === void 0 ? void 0 : _g.id)
            };
            const response = yield saveCsvFile.saveStudents(body);
            // console.log('response', response);
            setAddStudentsManuallyState(prev => (Object.assign(Object.assign({}, prev), { isLoading: false })));
            if (response.results) {
                // proceed to payment
                if (response.totalFailed > 0) {
                    showCustomError('Error', `${response.totalFailed} records failed to be added`);
                }
                setManageStudentsState(prev => (Object.assign(Object.assign({}, prev), { modalCheckout: true, totalStudentsCreated: response.totalCreated })));
            }
        }
        catch (error) {
            console.error('error', error);
            showCustomError('Error', 'Something went wrong!');
        }
    });
    const handleAdd = () => {
        if (manageStudentsState.isSemiAnnualPlan === 'yes') {
            if (manageStudentsState.students.total < TOTAL_STUDENTS_LIMIT_IN_SEMI_ANNUAL) {
                setAddStudentsManuallyState(prev => (Object.assign(Object.assign({}, prev), { modalAddStudent: true })));
            }
            else {
                setManageStudentsState(prev => (Object.assign(Object.assign({}, prev), { modalLimitExceeded: true })));
            }
        }
        else {
            setAddStudentsManuallyState(prev => (Object.assign(Object.assign({}, prev), { modalAddStudent: true })));
        }
    };
    const listTable = addStudentsManuallyState.studentsForSave.map((item, key) => {
        var _a;
        return {
            id: item.email,
            firstName: item.firstName,
            lastName: item.lastName,
            email: item.email,
            classGrade: `${(_a = item === null || item === void 0 ? void 0 : item.idClassSelected) === null || _a === void 0 ? void 0 : _a.label}`,
            actions: (React.createElement("div", { className: Styles.actionWrap },
                React.createElement(IconButton, { onClick: () => updateStudent(item) },
                    React.createElement(IconEdit, null)),
                React.createElement(IconButton, { onClick: () => toggleDeleteModal(item) },
                    React.createElement(IconTrash, null))))
        };
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(DefaultModal, { height: "90", hUnit: "%", width: "90", wUnit: "%", open: addStudentsManuallyState.mainModal, overlayCustomStyles: { zIndex: 9999 }, contentCustomStyles: { padding: 25 } },
            React.createElement("div", { className: classNames('d-flex w-100', Styles.mainModalHeader) },
                React.createElement("div", { className: classNames('d-flex w-100 flex-column', Styles.textPart) },
                    React.createElement("div", { className: Styles.title },
                        "Add students to the Class",
                        ' ',
                        `${(_b = mapToCardinal((_a = addStudentsManuallyState.classData) === null || _a === void 0 ? void 0 : _a.grades)) === null || _b === void 0 ? void 0 : _b.join(',')} e, ${(_c = addStudentsManuallyState.classData) === null || _c === void 0 ? void 0 : _c.name}`),
                    React.createElement("div", { className: Styles.subtitle }, "Please review and modify information if needed. All students will receive an invite in their emails.")),
                React.createElement("div", { className: classNames('d-flex w-100 justify-content-end', Styles.btnPart) },
                    React.createElement("div", { className: "px-1" },
                        React.createElement(ButtonBorderedKVBase, { type: "button", onClick: handleCancel, disabled: addStudentsManuallyState.isLoading }, "Cancel")),
                    React.createElement("div", { className: "px-1" },
                        React.createElement(ButtonKVBase, { type: "button", leftIcon: React.createElement(IconAddSimple, null), btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", onClick: handleAdd, disabled: addStudentsManuallyState.isLoading }, "Add")),
                    React.createElement("div", { className: "px-1" },
                        React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)", disabled: addStudentsManuallyState.studentsForSave.length < 1, onClick: proceedToPayment, loading: addStudentsManuallyState.isLoading }, "Proceed to Payment")))),
            React.createElement("div", { className: Styles.mainModalBody },
                React.createElement(CustomBootstrapTable, { keyField: "id", data: listTable, columns: columns, showMobile: isMobile }))),
        React.createElement(ModalAddStudent, { validation: validationAddStudent }),
        React.createElement(ModalMessage, { isOpen: addStudentsManuallyState.studentForRemove !== null, onClose: () => toggleDeleteModal(null) },
            React.createElement("div", { className: Styles.modalMessageWrap },
                React.createElement("div", { className: Styles.title }, "Remove Student?"),
                React.createElement("div", { className: Styles.detail }, `${(_d = addStudentsManuallyState.studentForRemove) === null || _d === void 0 ? void 0 : _d.firstName} ${(_e = addStudentsManuallyState.studentForRemove) === null || _e === void 0 ? void 0 : _e.lastName}`),
                React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)", onClick: confirmDeleteStudent }, "Confirm"),
                React.createElement(ButtonBorderedKVBase, { type: "button", color: '#999999', onClick: () => toggleDeleteModal(null) }, "Cancel")))));
};
const ModalMessage = ({ isOpen, onClose, children }) => {
    return (React.createElement(DefaultModal, { height: "300", hUnit: "px", width: "432", wUnit: "px", open: isOpen, onClose: onClose, overlayCustomStyles: { zIndex: 10000 } }, children));
};
export default ModalAddStudentsManually;
